import { useMutation } from "@tanstack/react-query";
import { updatePageStatus } from "../api/updatePageStatus";
import { invalidatePagesListByBrandsQuery } from "../queries/usePagesListByBrandQuery";

type Params = {
  isActive: boolean;
  pageId: string;
};

export const useUpdatePageStatusMutation = (brandId: string) => {
  return useMutation({
    mutationFn: async ({ isActive, pageId }: Params) => {
      return await updatePageStatus({
        isActive,
        brandId,
        pageId,
      });
    },
    onSuccess: () => {
      invalidatePagesListByBrandsQuery(brandId);
    },
    onError: (e) => {
      console.error("Error occurred when updating page", e);
    },
  });
};
